import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import UbuntuBase64 from '../assets/fonts/UbuntuBase64'
import UbuntuBoldBase64 from '../assets/fonts/UbuntuBoldBase64'
import logoImg from '../assets/images/logo-raudo.png'
import symbolyImg from '../assets/images/symboly.png'
import razitkoImg from '../assets/images/razitko-raudo.jpg'
import { fetchObjednavka } from '../services/api/objednavky'

const imageDataUrlCache = new Map()

const toNum = (value) => {
  if (value === null || value === undefined || value === '') return 0
  const n = Number(String(value).replace(',', '.').trim())
  return Number.isFinite(n) ? n : 0
}
const toTrim = (value) => String(value ?? '').trim()
const toBase64Payload = (asset) => {
  const str = String(asset || '')
  const idx = str.indexOf(',')
  return idx >= 0 ? str.slice(idx + 1) : str
}
const guessImageFormat = (dataUrl) => (String(dataUrl || '').startsWith('data:image/png') ? 'PNG' : 'JPEG')
const fileUrlToDataUrl = async (url) => {
  if (!url) return ''
  if (imageDataUrlCache.has(url)) return imageDataUrlCache.get(url)
  const response = await fetch(url)
  if (!response.ok) throw new Error(`Nepodarilo se nacist obrazek: ${url}`)
  const blob = await response.blob()
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(String(reader.result || ''))
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
  imageDataUrlCache.set(url, dataUrl)
  return dataUrl
}
const formatDate = (value) => {
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('cs-CZ', { year: 'numeric', month: '2-digit', day: '2-digit' })
}
const formatQty = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const formatMoney = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const formatPercent = (value) =>
  toNum(value).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 })

const printOrder = async (order) => {
  const idobj = Number(order?.idobj)
  if (!Number.isFinite(idobj) || idobj <= 0) {
    throw new Error('Chybí ID objednávky.')
  }

  const detail = await fetchObjednavka(idobj)
  const header = detail?.header || {}
  const items = Array.isArray(detail?.items) ? detail.items : []
  const orderNo = String(order?.cislo || header.CISLO || '').trim()
  const zakazkaRaw = toTrim(header.CISLO_ZAK)
  const zakazka = (zakazkaRaw && zakazkaRaw !== '0') ? zakazkaRaw : ''
  const zaklad = toNum(header.ZAKL0) + toNum(header.ZAKL1) + toNum(header.ZAKL2)
  const dph = toNum(header.DPH1) + toNum(header.DPH2)
  const celkem = toNum(header.CELKOM)

  let materialBezDph = 0
  let sluzbyBezDph = 0
  items.forEach((item) => {
    if (Number(item.TYP_RADKU) === 2) return
    const radekBezDph = toNum(item.POCETMJ) * toNum(item.CENAMJ)
    const typPol = String(item.TYP_POL || '').trim().toUpperCase()
    if (typPol === 'S') sluzbyBezDph += radekBezDph
    else materialBezDph += radekBezDph
  })

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
  const [logoDataUrl, symbolyDataUrl, razitkoDataUrl] = await Promise.all([
    fileUrlToDataUrl(logoImg),
    fileUrlToDataUrl(symbolyImg),
    fileUrlToDataUrl(razitkoImg)
  ])

  doc.addFileToVFS('Ubuntu-Regular.ttf', toBase64Payload(UbuntuBase64))
  doc.addFont('Ubuntu-Regular.ttf', 'Ubuntu', 'normal')
  doc.addFileToVFS('Ubuntu-Bold.ttf', toBase64Payload(UbuntuBoldBase64))
  doc.addFont('Ubuntu-Bold.ttf', 'Ubuntu', 'bold')

  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const marginX = 14
  const rightX = 108
  const rightW = pageWidth - rightX - marginX
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)

  if (logoDataUrl) doc.addImage(logoDataUrl, guessImageFormat(logoDataUrl), marginX, 12, 26, 6)
  const symbolX = pageWidth - marginX - 25
  const symbolY = 12
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Autodíly • Pneu • Servis', symbolX - 2, 15, { align: 'right' })
  doc.text('www.raudo.cz', symbolX - 2, 18, { align: 'right' })
  if (symbolyDataUrl) doc.addImage(symbolyDataUrl, guessImageFormat(symbolyDataUrl), symbolX, symbolY, 25, 7)

  doc.setFontSize(10)
  doc.setFont('Ubuntu', 'bold')
  doc.text('RAUDO - výrobní družstvo invalidů', marginX, 32)
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  const leftBlock = [
    'Uničovská 370/19',
    '787 01  Šumperk',
    '',
    'IČO:  26842998     DIČ:  CZ26842998',
    '',
    'zapsáno v obch. rejstříku vedeným Krajským soudem v Ostravě,',
    'oddíl Dr., vložka číslo 1797',
    'Banka:           ČSOB, a.s. / CEKO CZ PP',
    'Číslo účtu:    214745227 / 0300',
    'IBAN:             CZ84 0300 0000 0002 1474 5227',
    '',
    `Zakázka:      ${zakazka}`,
    `Středisko:    ${String(order?.stredisko || '').trim() || '-'}`,
    '',
  ]
  leftBlock.forEach((line, i) => doc.text(line, marginX, 37 + i * 4))

  doc.setDrawColor(0)
  doc.rect(rightX, 25, rightW, 20)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(12)
  doc.text(`ZAKÁZKOVÝ LIST č.: ${orderNo || '-'}`, rightX + 3, 32)
  doc.setFontSize(8)
  doc.setFont('Ubuntu', 'normal')
  doc.text(`Ze dne:     ${formatDate(header.DATUM || order?.vytvoreno) || '-'}`, rightX + 3, 37)
  doc.text(`Původní číslo: ${String(header.ORIGCISLO || '').trim() || ''}`, rightX + 3, 41)

  doc.rect(rightX, 46, rightW, 47)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Zákazník:', rightX + 3, 51)
  doc.text(`IČO: ${String(header.ICO || '').trim() || '-'}`, rightX + 23, 51)
  doc.text(`DIČ: ${String(header.DIC || '').trim() || '-'}`, rightX + 56, 51)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(9)
  const firma = toTrim(header.FIRMA) || '-'
  const firma2 = toTrim(header.FIRMA2)
  const meno = toTrim(header.MENO)
  const ulica = toTrim(header.ULICA)
  const pscMesto = `${toTrim(header.PSC)}  ${toTrim(header.MESTO)}`.trim()
  const stat = toTrim(header.STAT) || ''
  const addrLines = [firma, firma2, meno, ulica, pscMesto, stat].filter(Boolean)

  doc.text(addrLines[0] || '-', rightX + 3, 58)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(9)
  addrLines.slice(1).forEach((line, idx) => {
    doc.text(line, rightX + 3, 62 + idx * 4)
  })
  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  doc.text(`Tel.: ${String(header.TELEFON || '').trim()}`, rightX + 3, 85)
  doc.text(`E-mail: ${String(header.EMAIL || '').trim()}`, rightX + 3, 89)

  let tableStartY = 97
  const kpFirma = toTrim(header.KPFIRMA ?? header.kpfirma)
  const kpFirma2 = toTrim(header.KPFIRMA2 ?? header.kpfirma2)
  const kpMeno = toTrim(header.KPMENO ?? header.kpmeno)
  const kpUlice = toTrim(header.KPULICA ?? header.kpulica)
  const kpPsc = toTrim(header.KPPSC ?? header.kppsc)
  const kpMesto = toTrim(header.KPMESTO ?? header.kpmesto)
  const kpStat = toTrim(header.KPSTAT ?? header.kpstat)
  const kpIco = toTrim(header.ICOPRIJ ?? header.KPICO ?? header.kpico)
  const kpDic = toTrim(header.KPDIC ?? header.kpdic)
  const kpTel = toTrim(header.KPTELEFON ?? header.kptelefon)
  const kpEmail = toTrim(header.KPEMAIL ?? header.kpemail)
  const hasFinalRecipient = [kpFirma, kpFirma2, kpMeno, kpUlice, kpPsc, kpMesto, kpStat, kpIco, kpDic, kpTel, kpEmail].some(Boolean)

  if (hasFinalRecipient) {
    const blockTopY = 99
    const contentWidth = pageWidth - (marginX * 2)
    const leftX = marginX
    const rightColX = marginX + (contentWidth / 2) + 2

    doc.setFont('Ubuntu', 'bold')
    doc.setFontSize(8)
    doc.text('Konečný příjemce:', leftX, blockTopY)
    doc.text('Adresa:', rightColX, blockTopY)

    doc.setFont('Ubuntu', 'normal')
    let leftY = blockTopY + 5
    if (kpIco || kpDic) {
      doc.text(`IČO: ${kpIco || '-'}`, leftX, leftY)
      if (kpDic) doc.text(`DIČ: ${kpDic}`, leftX + 42, leftY)
      leftY += 4
    }
    if (kpTel) {
      doc.text(`Tel.: ${kpTel}`, leftX, leftY)
      leftY += 4
    }
    if (kpEmail) {
      doc.text(`E-mail: ${kpEmail}`, leftX, leftY)
      leftY += 4
    }

    const kpPscMesto = `${kpPsc}  ${kpMesto}`.trim()
    const rightLines = [kpFirma, kpFirma2, kpMeno, kpUlice, kpPscMesto, kpStat].filter(Boolean)
    rightLines.forEach((line, idx) => {
      doc.text(line, rightColX, blockTopY + 5 + (idx * 4))
    })

    const leftBottomY = leftY > blockTopY + 5 ? leftY - 1 : blockTopY + 5
    const rightBottomY = rightLines.length ? (blockTopY + 5 + ((rightLines.length - 1) * 4)) : (blockTopY + 5)
    tableStartY = Math.max(leftBottomY, rightBottomY) + 6
  }

  const getItemDiscount = (item) => toNum(item.ZLAVA ?? item.SLEVA ?? item.ZLAVA_PCT ?? 0)
  const hasDiscountColumn = items.some((item) => Number(item.TYP_RADKU) !== 2 && getItemDiscount(item) > 0)
  const bodyRows = items.length
    ? items.map((item) => {
      const cleanLine = (value) =>
        String(value || '')
          .replace(/[\r\n\u2028\u2029\t]+/g, ' ')
          .replace(/\u00A0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      const isTextRow = Number(item.TYP_RADKU) === 2
      if (isTextRow) {
        const textOnly = cleanLine(toTrim(item.TEXT))
        if (!textOnly) return null
        return [{ content: textOnly, colSpan: hasDiscountColumn ? 7 : 6, styles: { fontStyle: 'normal', cellPadding: { top: 0.5, right: 0.7, bottom: 0, left: 0.5 } } }]
      }
      const qtyNum = toNum(item.POCETMJ)
      const cenaNum = toNum(item.CENAMJ)
      const sazbaNum = toNum(item.SADZBADPH)
      const slevaNum = getItemDiscount(item)
      const totalWithDph = qtyNum * cenaNum * (1 - slevaNum / 100) * (1 + sazbaNum / 100)
      const rowText = cleanLine(toTrim(item.TEXT))
      const mj = toTrim(item.MJ)
      const row = [
        rowText,
        mj,
        formatQty(qtyNum),
        formatMoney(cenaNum),
        `${formatPercent(sazbaNum)}%`
      ]
      if (hasDiscountColumn) row.push(slevaNum > 0 ? toTrim(`${formatPercent(slevaNum)}%`) : '')
      row.push(formatMoney(totalWithDph))
      return row
    }).filter(Boolean)
    : [hasDiscountColumn ? ['Bez položek', '', '', '', '', '', ''] : ['Bez položek', '', '', '', '', '']]

  autoTable(doc, {
    startY: tableStartY,
    margin: { left: marginX, right: marginX, top: 22 },
    theme: 'plain',
    head: [hasDiscountColumn
      ? ['Položka zakázky:', 'MJ', 'Počet MJ', 'Cena MJ\nbez DPH', 'DPH\n(%)', 'Sleva\n(%)', 'Celkem (CZK)\ns DPH']
      : ['Položka zakázky:', 'MJ', 'Počet MJ', 'Cena MJ\nbez DPH', 'DPH\n(%)', 'Celkem (CZK)\ns DPH']],
    body: bodyRows,
    styles: {
      font: 'Ubuntu',
      fontSize: 8,
      lineHeight: 1.0,
      minCellHeight: 0,
      cellPadding: { top: 0.75, right: 0.5, bottom: 0.1, left: 0.5 },
      valign: 'top',
      lineColor: 20,
      lineWidth: 0
    },
    headStyles: {
      font: 'Ubuntu',
      fontStyle: 'bold',
      lineHeight: 1.0,
      cellPadding: { top: 0.5, right: 0.7, bottom: 1.1, left: 0.5 },
      halign: 'left',
      lineWidth: { bottom: 0.3 },
      lineColor: 0
    },
    bodyStyles: { lineWidth: 0 },
    didParseCell: (hookData) => {
      const col = hookData.column?.index
      const isNumericCol = hasDiscountColumn
        ? col === 2 || col === 3 || col === 4 || col === 5 || col === 6
        : col === 2 || col === 3 || col === 4 || col === 5
      const isCenterCol = col === 1
      if (hookData.section === 'head') {
        if (isCenterCol) hookData.cell.styles.halign = 'center'
        else if (isNumericCol) hookData.cell.styles.halign = 'right'
        else hookData.cell.styles.halign = 'left'
        return
      }
      if (hookData.section !== 'body') return
      hookData.cell.styles.minCellHeight = 0
      hookData.cell.styles.lineHeight = 0.9
      hookData.cell.styles.cellPadding = { top: 0.75, right: 0.5, bottom: 0.1, left: 0.5 }
      if (isCenterCol) hookData.cell.styles.halign = 'center'
      else if (isNumericCol) hookData.cell.styles.halign = 'right'
      else hookData.cell.styles.halign = 'left'
    },
    columnStyles: hasDiscountColumn
      ? {
          0: { cellWidth: 90 },
          1: { cellWidth: 10, halign: 'center' },
          2: { cellWidth: 18, halign: 'right' },
          3: { cellWidth: 20, halign: 'right' },
          4: { cellWidth: 12, halign: 'right' },
          5: { cellWidth: 12, halign: 'right' },
          6: { cellWidth: 20, halign: 'right' }
        }
      : {
          0: { cellWidth: 102 },
          1: { cellWidth: 10, halign: 'center' },
          2: { cellWidth: 18, halign: 'right' },
          3: { cellWidth: 20, halign: 'right' },
          4: { cellWidth: 12, halign: 'right' },
          5: { cellWidth: 20, halign: 'right' }
        }
  })

  const afterTableY = doc.lastAutoTable?.finalY || 122
  doc.setLineWidth(0.25)
  doc.line(marginX, afterTableY + 0.8, pageWidth - marginX, afterTableY + 0.8)

  const summaryToFooterOffset = 34
  const summaryBlockHeight = 23
  const footerMinY = 239
  const footerBlockHeight = 43
  const bottomSafeMargin = 14
  const summaryStartCandidate = afterTableY + 7
  const canRenderSummaryOnCurrentPage =
    (summaryStartCandidate + summaryBlockHeight) <= (pageHeight - bottomSafeMargin)
  if (!canRenderSummaryOnCurrentPage) {
    doc.addPage()
  }
  const summaryY = canRenderSummaryOnCurrentPage ? summaryStartCandidate : 40
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Souhrn detailního rozpisu práce (hod):', marginX, summaryY)
  doc.text('0,00', marginX + 60, summaryY)
  doc.setFont('Ubuntu', 'normal')
  doc.text('Celkem materiál bez DPH:', pageWidth - 78, summaryY)
  doc.text(formatMoney(materialBezDph), pageWidth - 14, summaryY, { align: 'right' })
  doc.text('Celkem služby bez DPH:', pageWidth - 78, summaryY + 5)
  doc.text(formatMoney(sluzbyBezDph), pageWidth - 14, summaryY + 5, { align: 'right' })
  doc.text('Celkem zakázka bez DPH:', pageWidth - 78, summaryY + 10)
  doc.text(formatMoney(zaklad), pageWidth - 14, summaryY + 10, { align: 'right' })
  doc.text('Celkem DPH:', pageWidth - 78, summaryY + 15)
  doc.text(formatMoney(dph), pageWidth - 14, summaryY + 15, { align: 'right' })
  doc.line(pageWidth - 78, summaryY + 17.5, pageWidth - 14, summaryY + 17.5)
  doc.setFont('Ubuntu', 'bold')
  doc.setFontSize(8)
  doc.text('Celkem k úhradě:', pageWidth - 78, summaryY + 22)
  doc.setFontSize(10)
  doc.text(formatMoney(celkem), pageWidth - 14, summaryY + 22, { align: 'right' })

  let contentEndY = summaryY + 22
  const poznamkaRaw = String(header.POZNAMKA ?? '').replace(/\r\n/g, '\n').trim()
  if (poznamkaRaw) {
    const noteTopGap = 8
    const noteBottomGap = 6
    const noteLineHeight = 4
    const noteMaxWidth = pageWidth - (marginX * 2)
    const noteLines = doc.splitTextToSize(poznamkaRaw, noteMaxWidth)
    const noteBlockHeight = noteTopGap + 4 + (noteLines.length * noteLineHeight) + noteBottomGap
    const contentLimitY = pageHeight - bottomSafeMargin - footerBlockHeight - 6
    if ((contentEndY + noteBlockHeight) > contentLimitY) {
      doc.addPage()
      contentEndY = 30
    }
    const noteY = contentEndY + noteTopGap
    doc.setFont('Ubuntu', 'bold')
    doc.setFontSize(8)
    doc.text('Poznámka:', marginX, noteY)
    doc.setFont('Ubuntu', 'normal')
    doc.text(noteLines, marginX, noteY + 4)
    contentEndY = noteY + 4 + (noteLines.length * noteLineHeight) + noteBottomGap
  }

  const footerStartY = Math.max(contentEndY + 8, footerMinY)
  const needsNewPage = (footerStartY + footerBlockHeight) > (pageHeight - bottomSafeMargin)
  if (needsNewPage) {
    doc.addPage()
  }
  const fy = pageHeight - bottomSafeMargin - footerBlockHeight

  doc.setFont('Ubuntu', 'normal')
  doc.setFontSize(8)
  doc.text('Vystavil:', marginX, fy)
  doc.text('Telefon: +420 588 500 021  E-mail: raudo@raudo.cz', marginX, fy + 4)
  doc.line(marginX - 1, fy + 6, pageWidth - marginX, fy + 6)

  doc.setFont('Ubuntu', 'bold')
  doc.text('Potvrzení objednávky:', marginX, fy + 12)
  doc.setFont('Ubuntu', 'normal')
  doc.text('Termín dodání:', marginX + 5, fy + 18)
  doc.text('-----------------------------', marginX + 27, fy + 20)
  doc.text('Datum:', marginX + 15, fy + 30)
  doc.text('-----------------------------', marginX + 27, fy + 32)

  const signTopY = fy + 8
  const signBaseY = fy + 31
  const midX = pageWidth / 2 + 30
  doc.line(midX, fy + 6, midX, signBaseY + 6)
  doc.line(marginX + 58, signBaseY, midX - 8, signBaseY)
  doc.line(midX + 8, signBaseY, pageWidth - marginX, signBaseY)
  if (razitkoDataUrl) {
    doc.addImage(razitkoDataUrl, guessImageFormat(razitkoDataUrl), pageWidth / 2 - 30, signTopY, 45, 20)
  }
  doc.text('Dodavatel (podpis, razítko)', pageWidth / 2 - 6, signBaseY + 4, { align: 'center' })
  doc.text('Zákazník (podpis, razítko)', pageWidth - 41, signBaseY + 4, { align: 'center' })

  doc.setFontSize(8)
  doc.text('#UC110194-50, program firmy © MRP - Informatics, s.r.o., P.O.BOX 35, 763 15 Slušovice', marginX - 1, signBaseY + 10)

  const totalPages = doc.getNumberOfPages()
  for (let page = 1; page <= totalPages; page += 1) {
    doc.setPage(page)
    if (page === 1) {
      doc.setFont('Ubuntu', 'normal')
      doc.setFontSize(8)
      doc.text(`Strana ${page} / ${totalPages}`, marginX, 89)
      continue
    }
    doc.setFont('Ubuntu', 'bold')
    doc.setFontSize(10)
    doc.text(`Zakázkový list č. ${orderNo || '-'} (pokračování)`, marginX, 14)
    doc.setFont('Ubuntu', 'normal')
    doc.setFontSize(8)
    doc.text(`Strana ${page} / ${totalPages}`, pageWidth - marginX, 14, { align: 'right' })
    doc.setLineWidth(0.25)
    doc.line(marginX - 1, 17, pageWidth - marginX, 17)
  }
  doc.autoPrint()
  const blobUrl = doc.output('bloburl')
  if (typeof window !== 'undefined') window.open(blobUrl, '_blank', 'noopener,noreferrer')
}




const OrdersPrintTrigger = ({ order, disabled = false, onError, renderButton }) => {
  const handleClick = async (event) => {
    event?.stopPropagation?.()
    if (disabled) return
    try {
      await printOrder(order)
    } catch (error) {
      onError?.(error)
    }
  }

  if (typeof renderButton === 'function') {
    return renderButton({ onClick: handleClick, disabled })
  }

  return (
    <button type="button" onClick={handleClick} disabled={disabled}>
      Tisk
    </button>
  )
}

export default OrdersPrintTrigger
